import React from "react";
import { FaXmark } from "react-icons/fa6";
import { FaCheck, FaUser, FaUsers } from "react-icons/fa";

const HasSiblings = ({ hasSiblings, count = 0 }) => {
    return hasSiblings ? (
        <FaUsers className="text-indigo-500" title={`Heeft ${count} broer(s)/zus(sen)`} />
    ) : (
        <FaUser className="text-indigo-500" title="Geen broers of zussen" />
    );
};

export default HasSiblings;